import DropdownItem from '../DropdownItem'

const SingleItemList = ({ item }) =>
  <DropdownItem
    title={item.title}
    href={item.href}
    onClick={(e) => {
      item.onClick(e)
    }}
    variant={item.variant}
    customClass={item.class}
    value={item.value}
    image={item.image}
    disabled={item.disabled}
  />

export default SingleItemList
